import styled, { css } from 'styled-components';

export const LabelArea = styled.div``;

export const ContentArea = styled.div``;

export const LabelText = styled.p`
  font-weight: bold;
  margin: 0 0.2rem 0 0;
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    white-space: normal;
  }
`;

export const ContentText = styled.p`
  margin-bottom: 0;
  word-break: break-word;
`;

interface IContainerProps {
  $isEllipsisText?: boolean;
}
export const Container = styled.div<IContainerProps>`
  display: flex;
  align-items: center;
  margin: 0 0 0.2rem;

  ${({ $isEllipsisText }) =>
    $isEllipsisText &&
    css`
      ${LabelArea}, ${ContentArea} {
        display: grid;
        grid-auto-flow: column;
      }

      ${ContentText} {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

